import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import TwSlider from '../../../../../TwSlider';
import currencySymbol from '../../../../../../helpers/currencySymbol';

const Sliders = ({
  budget,
  onBudgetChange,
  min,
  max,
  currencyCode,
}) => {
  const [displayBudget, setDisplayBudget] = useState(budget || [0, 0]);

  const handleDisplayBudgetChange = (event, newValue) => {
    setDisplayBudget(newValue);
  };

  const formatNumber = useCallback((value) => (
    <NumberFormat value={value} displayType="text" thousandSeparator prefix={currencySymbol(currencyCode)} />
  ), [currencyCode]);

  const fromPrice = useMemo(() => formatNumber(displayBudget[0]), [displayBudget, formatNumber]);
  const toPrice = useMemo(() => formatNumber(displayBudget[1]), [displayBudget, formatNumber]);

  return (
    <div className="w-64">
      <div className="grid grid-cols-3 mb-1">
        <div className="text-sm text-gray-700">
          Budget:
          {' '}
        </div>
        <div className="col-span-2 text-right text-sm text-gray-700">
          {fromPrice}
          {' '}
          -
          {' '}
          {toPrice}
        </div>
      </div>
      <TwSlider
        value={displayBudget}
        onChange={handleDisplayBudgetChange}
        onChangeCommitted={onBudgetChange}
        min={min}
        max={max}
        step={1}
      />
    </div>
  );
};

Sliders.propTypes = {
  budget: PropTypes.arrayOf(PropTypes.number).isRequired,
  onBudgetChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  currencyCode: PropTypes.string,
};

Sliders.defaultProps = {
  min: null,
  max: null,
  currencyCode: 'USD',
};

export default React.memo(Sliders);
